import React, { useContext, useState } from "react";
import { TableContext } from "../index";
import { CardTypes } from "./UserCardService";
import SearchInputV2 from "../view/SearchInputV2";

function UserTableHeader() {

    const { config, setConfig } = useContext(TableContext);

    // Search state
    const [searchTerm, setSearchTerm] = useState('');

    const handleSearch = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        setConfig({ ...config, searchTerm: value });
    };

    const onCreateClick = () => {
        const { showModal } = config;
        showModal({ cardType: CardTypes.CREATE })
    }

    return (
        <>
            <div className="d-flex justify-content-between align-items-center px-4 mb-0 mt-0">
                <div className="oct_analysis-actions">
                    <button
                        className="oct_btn-export-v2"
                        onClick={onCreateClick}
                    >
                        Create
                    </button>
                </div>
                <div className="m-0 mt-0">
                    <SearchInputV2
                        value={searchTerm}
                        onChange={handleSearch}
                        placeholder="Search in users..."
                        className="m-0"
                    />
                </div>
            </div>
        </>
    );
}

export default UserTableHeader;
